import { ArrowBtn as e, ArrowGroup as t, Dot as n, DotsRow as r, HeaderEnd as i, HeaderRow as a, OverlayArrowBtn as o, PageIndicator as ee, Subtitle as s, TitleBlock as c, VerticalDot as te } from "./styled/CarouselControls.styled.mjs";
import { CarouselTitle as ne } from "./CarouselTitle.mjs";
import { EdgeFade as re, ItemOuter as ie, Track as ae, TrackViewport as oe } from "./styled/CarouselTrack.styled.mjs";
import { HorizontalLayout as se, HorizontalTrackRow as ce, VerticalArrowRow as l, VerticalDots as le, VerticalLayout as ue } from "./styled/CarouselLayouts.styled.mjs";
import { Children as de, useCallback as fe, useEffect as u, useRef as d, useState as f } from "react";
import { useTranslation as pe } from "@maat/store-i18n";
import { Fragment as me, jsx as p, jsxs as m } from "react/jsx-runtime";
import { ChevronDown as he, ChevronLeft as h, ChevronRight as ge, ChevronUp as _e } from "lucide-react";
//#region src/components/Carousel/Carousel.tsx
var g = ({ children: g, orientation: _ = "horizontal", title: v, icon: y, titleStyles: ve, subtitle: b, onTitleClick: x, titleHref: S, showDots: C = !0, showArrows: w = !0, showPageIndicator: ye = !1, overlayArrows: be = !1, overlayDots: T = !1, arrowVariant: E = "default", arrowSize: D = "md", gap: O = 16, autoPlay: k = 0, itemSize: xe, snap: A = !1, shadowBleed: j = 0, selectedIndex: Se, onItemClick: Ce, headerActions: M, className: N }) => {
	let { t: P } = pe("ds"), F = d(null), I = d(null), [L, R] = f(0), [z, B] = f(1), [V, H] = f(!1), [U, W] = f(!0), we = Se, G = de.toArray(g), K = G.length, q = fe(() => {
		let e = F.current, t = I.current;
		if (!e || !t) return;
		let n = t.firstElementChild;
		if (n) if (_ === "horizontal") {
			let t = n.offsetWidth + O, r = Math.max(1, Math.floor(e.clientWidth / t));
			B(Math.max(1, Math.ceil(K / r)));
		} else {
			let t = n.offsetHeight + O, r = Math.max(1, Math.floor(e.clientHeight / t));
			B(Math.max(1, Math.ceil(K / r)));
		}
	}, [
		_,
		O,
		K
	]);
	u(() => {
		let e = F.current;
		if (!e) return;
		let t = new ResizeObserver(() => {
			requestAnimationFrame(q);
		});
		return t.observe(e), requestAnimationFrame(q), () => t.disconnect();
	}, [q]);
	let J = fe(() => {
		let e = F.current, t = I.current;
		if (!(!e || !t)) if (_ === "horizontal") {
			let n = e.scrollLeft, r = t.scrollWidth - e.clientWidth;
			H(n > 2);
			let i = n >= r - 2;
			W(!i);
			let a = t.firstElementChild;
			if (a) {
				let t = a.offsetWidth + O, r = t * Math.max(1, Math.floor(e.clientWidth / t)), o = i ? z - 1 : Math.round(n / r);
				R(Math.min(o, z - 1));
			}
		} else {
			let n = e.scrollTop, r = t.scrollHeight - e.clientHeight;
			H(n > 2);
			let i = n >= r - 2;
			W(!i);
			let a = t.firstElementChild;
			if (a) {
				let t = a.offsetHeight + O, r = t * Math.max(1, Math.floor(e.clientHeight / t)), o = i ? z - 1 : Math.round(n / r);
				R(Math.min(o, z - 1));
			}
		}
	}, [
		_,
		O,
		z
	]);
	u(() => {
		let e = F.current;
		if (!e) return;
		e.addEventListener("scroll", J, { passive: !0 });
		let t = requestAnimationFrame(J);
		return () => {
			e.removeEventListener("scroll", J), cancelAnimationFrame(t);
		};
	}, [J]);
	let Te = () => {
		let e = I.current, t = F.current;
		if (!e || !t) return 300;
		let n = e.firstElementChild;
		if (!n) return 300;
		if (_ === "horizontal") {
			let e = n.offsetWidth + O;
			return e * Math.max(1, Math.floor(t.clientWidth / e));
		} else {
			let e = n.offsetHeight + O;
			return e * Math.max(1, Math.floor(t.clientHeight / e));
		}
	}, Y = (e) => {
		let t = F.current;
		if (!t) return;
		let n = Te() * e;
		_ === "horizontal" ? t.scrollBy({
			left: n,
			behavior: "smooth"
		}) : t.scrollBy({
			top: n,
			behavior: "smooth"
		});
	}, X = (e) => {
		let t = F.current;
		if (!t) return;
		let n = e * Te();
		_ === "horizontal" ? t.scrollTo({
			left: n,
			behavior: "smooth"
		}) : t.scrollTo({
			top: n,
			behavior: "smooth"
		});
	};
	u(() => {
		if (!k) return;
		let e = setInterval(() => {
			U ? Y(1) : X(0);
		}, k);
		return () => clearInterval(e);
	}, [k, U]);
	let Ee = (e) => {
		Ce?.(e);
	}, Z = _ === "vertical", De = /* @__PURE__ */ p(oe, {
		ref: F,
		$orientation: _,
		$snap: A,
		$bleed: Z ? 0 : j,
		style: Z ? { maxHeight: 480 } : void 0,
		children: /* @__PURE__ */ p(ae, {
			ref: I,
			$orientation: _,
			$gap: O,
			$bleed: Z ? 0 : j,
			children: G.map((e, t) => /* @__PURE__ */ p(ie, {
				$orientation: _,
				$itemSize: xe,
				$snap: A,
				$selected: we === t,
				onClick: () => Ee(t),
				children: e
			}, t))
		})
	}), Oe = !!(v || b);
	if (Z) return /* @__PURE__ */ m(ue, {
		className: N,
		children: [
			Oe && /* @__PURE__ */ p(a, { children: /* @__PURE__ */ m(c, { children: [/* @__PURE__ */ p(ne, {
				title: v,
				icon: y,
				href: S,
				onClick: x
			}), b && /* @__PURE__ */ p(s, { children: b })] }) }),
			w && /* @__PURE__ */ p(l, { children: /* @__PURE__ */ p(e, {
				$disabled: !V,
				onClick: () => Y(-1),
				"aria-label": P("ds:carousel.previous"),
				children: /* @__PURE__ */ p(_e, { size: 15 })
			}) }),
			De,
			w && /* @__PURE__ */ p(l, { children: /* @__PURE__ */ p(e, {
				$disabled: !U,
				onClick: () => Y(1),
				"aria-label": P("ds:carousel.next"),
				children: /* @__PURE__ */ p(he, { size: 15 })
			}) }),
			C && z > 1 && /* @__PURE__ */ p(le, { children: Array.from({ length: z }).map((e, t) => /* @__PURE__ */ p(te, {
				$active: t === L,
				onClick: () => X(t),
				"aria-label": `Page ${t + 1}`
			}, t)) })
		]
	});
	let Q = _ === "horizontal" && be && w, $ = ye && z > 1;
	return /* @__PURE__ */ m(se, {
		className: N,
		children: [
			(Oe || M || $ || w && !Q) && /* @__PURE__ */ m(a, { children: [/* @__PURE__ */ m(c, { children: [v && /* @__PURE__ */ p(ne, {
				title: v,
				icon: y,
				style: ve,
				href: S,
				onClick: x
			}), b && /* @__PURE__ */ p(s, { children: b })] }), (w && !Q || M || $) && /* @__PURE__ */ m(i, { children: [
				$ && /* @__PURE__ */ p(ee, { children: P("ds:carousel.pageIndicator", {
					page: L + 1,
					count: z
				}) }),
				w && !Q && /* @__PURE__ */ m(t, { children: [/* @__PURE__ */ p(e, {
					$disabled: !V,
					$variant: E,
					$size: D,
					onClick: () => Y(-1),
					"aria-label": P("ds:carousel.previous"),
					children: /* @__PURE__ */ p(h, { size: 15 })
				}), /* @__PURE__ */ p(e, {
					$disabled: !U,
					$variant: E,
					$size: D,
					onClick: () => Y(1),
					"aria-label": P("ds:carousel.next"),
					children: /* @__PURE__ */ p(ge, { size: 15 })
				})] }),
				M
			] })] }),
			/* @__PURE__ */ m(ce, {
				$hasOverlayArrows: Q,
				children: [
					Q && /* @__PURE__ */ p(o, {
						$side: "left",
						$disabled: !V,
						$variant: E,
						$size: D,
						onClick: (e) => {
							e.stopPropagation(), Y(-1);
						},
						"aria-label": P("ds:carousel.previous"),
						children: /* @__PURE__ */ p(h, { size: 15 })
					}),
					De,
					!Q && /* @__PURE__ */ m(me, { children: [/* @__PURE__ */ p(re, {
						$side: "left",
						$visible: V,
						$bleed: j,
						"aria-hidden": !0
					}), /* @__PURE__ */ p(re, {
						$side: "right",
						$visible: U,
						$bleed: j,
						"aria-hidden": !0
					})] }),
					Q && /* @__PURE__ */ p(o, {
						$side: "right",
						$disabled: !U,
						$variant: E,
						$size: D,
						onClick: (e) => {
							e.stopPropagation(), Y(1);
						},
						"aria-label": P("ds:carousel.next"),
						children: /* @__PURE__ */ p(ge, { size: 15 })
					})
				]
			}),
			C && z > 1 && /* @__PURE__ */ p(r, {
				$overlay: T,
				children: Array.from({ length: z }).map((e, t) => /* @__PURE__ */ p(n, {
					$active: t === L,
					$overlay: T,
					onClick: (e) => {
						e.stopPropagation(), X(t);
					},
					"aria-label": `Page ${t + 1}`
				}, t))
			})
		]
	});
}, _ = (e) => /* @__PURE__ */ p(g, {
	...e,
	orientation: "horizontal"
}), v = (e) => /* @__PURE__ */ p(g, {
	...e,
	orientation: "vertical"
});
//#endregion
export { g as Carousel, _ as HorizontalCarousel, v as VerticalCarousel };
